const CD_TP_EVENTO_INTERNO = 5;
const SG_TP_EVENTO_INTERNO = "CI";

export function isEventoInterno(evento: any): boolean {
  if (!evento) return false;
  const tipo =
    evento.tipoEvento ||
    evento.dsTpEvento ||
    evento.cdTpEventoNavigation?.dsTpEvento;
  if (tipo === "Consulta Interna") return true;
  return (
    Number(evento.cdTpEvento) === CD_TP_EVENTO_INTERNO ||
    evento.cdTpEventoNavigation?.sgTpEvento === SG_TP_EVENTO_INTERNO ||
    evento.cdTpEventoNavigation?.dsTpEvento === "Consulta Interna"
  );
}

export function idDoEvento(evento: any) {
  return evento?.id ?? evento?.codAudienciaPublica ?? evento?.codigoAudienciaPublica;
}

export function encerrarSessaoEventoInterno() {
  sessionStorage.removeItem("membro");
  sessionStorage.removeItem("authToken");
  sessionStorage.removeItem("internalAccess");
  sessionStorage.removeItem("idEventoInterno");
  sessionStorage.removeItem("login");
}

function getAccessTokenFromUser(): string | null {
  try {
    const userStr = sessionStorage.getItem("user");
    if (!userStr || userStr === "undefined" || userStr.trim() === "") {
      return null;
    }
    const user = JSON.parse(userStr);
    return user?.accessToken ?? null;
  } catch {
    return null;
  }
}

export function hasSessaoEventoInterno(): boolean {
  return (
    sessionStorage.getItem("internalAccess") === "true" &&
    sessionStorage.getItem("idEventoInterno") != null &&
    (sessionStorage.getItem("authToken") != null ||
      getAccessTokenFromUser() != null)
  );
}

export function configurarSessaoEventoInterno(params: {
  accessToken: string;
  login: string;
  idEvento: string | number;
}) {
  sessionStorage.setItem("authToken", params.accessToken);
  sessionStorage.setItem("internalAccess", "true");
  sessionStorage.setItem("login", params.login);
  sessionStorage.setItem("idEventoInterno", String(params.idEvento));
}

export function isRotaEventoInterno(pathname: string): boolean {
  return (
    pathname.startsWith("/evento-interno") ||
    pathname.startsWith("/evento-interno-contribuicao")
  );
}

/** Igual ao fluxo evento-interno-auth: oculta sidebar e menu do topbar. */
export function ativarLayoutEventoInterno() {
  sessionStorage.setItem("internalAccess", "true");
}

export function shouldOcultarSidebarEventoInterno(pathname: string): boolean {
  if (sessionStorage.getItem("internalAccess") === "true") {
    return true;
  }
  return isRotaEventoInterno(pathname);
}
